import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const ServicesPage = lazy(() => import("../pages/services/page"));
const OurWorkPage = lazy(() => import("../pages/our-work/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/our-work",
    element: <OurWorkPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
